import React, { useState } from "react";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "components/Button";
import LeftContainer from "components/LeftContainer";
import AlertModal from "components/AlertModal";
import EmailFieldInput from "components/FormElements/EmailFieldInput";
import SuccessMsg from "components/SuccessMsg";
import SignInLogo from "assets/svg/Logo";
import KeyIcon from "assets/svg/ForgetPasswordKeyIcon";
import BackToLogInIcon from "assets/svg/BackToLogIn";
import { forgotPassword } from "redux/actions/forgotPassword";
import {
  getAuthInitialValues,
  VALIDATION_SCHEMA,
} from "utils/forgotPasswordUtils";
import { Heading, SubHeading } from "styles/pages/forgotPassword";
import { useText } from "locales/useGetText";

import {
  BodyContainer,
  RegistrationContainer,
  FormContainer,
  InputField,
  Footer,
  Container,
  RightContainer,
  LogoWrapper,
} from "styles/pages/global";

const ForgotPassword = () => {
  const locale = useText("forgotPassword");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  const [successState, setSuccessState] = useState(false);
  const [response, setResponse] = useState({
    paload: "",
    buttonName: "OK",
    navigationLink: "/",
    heading: locale("checkYourEmail"),
    description: locale("passwordResetSent"),
  });

  const formSubmit = async (props) => {
    const { submitForm, isValid } = props;

    submitForm().then(async () => {
      if (isValid) {
        let data = {
          email: props?.values?.email,
        };

        const response = await dispatch(forgotPassword(data));
        if (response?.data?.success) {
          setSuccessState(true);
          setResponse({
            ...response,
            paload: "",
            buttonName: "OK",
            navigationLink: "/",
            heading: locale("checkYourEmail"),
            description: locale("passwordResetSent"),
          });
        } else {
          setSuccessState(false);
          setModalContent(response?.data?.error?.message);
          setModalLink("");
          toggleModal();
        }
      }
    });
  };

  const formFields = () => {
    return (
      <Container>
        <LeftContainer />
        <RightContainer>
          <RegistrationContainer>
            <LogoWrapper className="for-forget-password">
              <SignInLogo />
            </LogoWrapper>
            <>
              {!successState && <KeyIcon className="key-icon" />}

              <Formik
                initialValues={getAuthInitialValues()}
                validationSchema={VALIDATION_SCHEMA(locale)}
                onSubmit={() => {}}
              >
                {(props) => {
                  const { isValid, dirty } = props;
                  return (
                    <Form>
                      <FormContainer>
                        {!successState ? (
                          <>
                            <Heading>{locale("forgotPasswordTitle")}</Heading>
                            <SubHeading>
                              {locale("forgotPasswordSubTitle")}
                            </SubHeading>
                            <InputField data-testid="Email*">
                              <EmailFieldInput
                                name="email"
                                placeholder={locale("emailRequiredPlaceholder")}
                                maxLength={100}
                                showErrorMessages={true}
                              />
                            </InputField>

                            <Footer>
                              <Button
                                disabled={!(isValid && dirty)}
                                handleClick={() => formSubmit(props)}
                              >
                                {locale("sendPasswordResetInstructions")}
                              </Button>
                            </Footer>
                          </>
                        ) : (
                          <>
                            <SuccessMsg
                              response={response}
                              locale={locale}
                              actionType="forgotPassword"
                              icon={KeyIcon}
                              callBack={() => {
                                formSubmit(props);
                              }}
                            />
                          </>
                        )}
                        <h5
                          className="back-to-login"
                          onClick={() => navigate("/")}
                        >
                          <BackToLogInIcon />
                          {locale("backToLogin")}
                        </h5>
                      </FormContainer>
                    </Form>
                  );
                }}
              </Formik>
            </>

            <AlertModal
              isOpen={modal}
              toggle={toggleModal}
              title={locale("alert")}
              content={modalContent}
              link={modalLink}
              className="alert-msg-container"
              InnerClassName="alert-msg"
            />
          </RegistrationContainer>
        </RightContainer>
      </Container>
    );
  };

  return <BodyContainer>{formFields()}</BodyContainer>;
};

export default ForgotPassword;
